import React from "react";
import styled from "styled-components";

import { Card, Col } from "reactstrap";
import { theme } from "../../constants/theme";

const FAQCardComponent = styled(Card)`
  border-radius: ${theme.radius.lg};
  border: 1px solid ${theme.color.border};
  background-color: ${theme.color.surface};
  color: ${theme.color.text};
  margin: 0 0 0.75rem 0;
  padding: 0;
  text-align: left;
  box-shadow: ${theme.shadow.sm};
  transform: none !important;
  transition: box-shadow ${theme.motion.base}, border-color ${theme.motion.base};

  &:hover {
    transform: none !important;
    box-shadow: ${theme.shadow.md};
    border-color: ${theme.color.borderStrong};
  }

  .card-header {
    background-color: transparent;
    border-radius: ${theme.radius.lg};
    border-bottom: none;
    font-family: ${theme.font.display};
    font-weight: ${theme.weight.semibold};
    font-size: 1.2rem;
    letter-spacing: -0.015em;
    color: ${theme.color.slate};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 1.15rem 1.75rem;

    &::after {
      content: "";
      width: 10px;
      height: 10px;
      border-right: 2px solid ${theme.color.textMuted};
      border-bottom: 2px solid ${theme.color.textMuted};
      transform: rotate(-45deg);
      transition: transform ${theme.motion.base};
      display: inline-block;
      flex-shrink: 0;
      margin-right: 4px;
    }
  }

  .card-header[data-open="true"]::after {
    transform: rotate(45deg);
    margin-right: 0;
    margin-top: -4px;
  }

  .card-body {
    font-family: ${theme.font.body};
    font-weight: 400;
    font-size: 0.9375rem;
    line-height: 1.7;
    color: ${theme.color.text};
    padding: 0 1.75rem 1.25rem;
  }

  a {
    color: ${theme.color.teal} !important;
    font-weight: ${theme.weight.medium};
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;
    transition: color ${theme.motion.base};

    &:hover {
      color: ${theme.color.salmonDeep} !important;
    }
  }
`;

export const FAQContainer = styled(Col)`
  padding: 1rem;

  .card:last-child {
    padding-bottom: 1rem;
  }
`;

const FAQCard = ({ children, id }) => (
  <FAQCardComponent id={id}>{children}</FAQCardComponent>
);

export default FAQCard;
